import React from 'react';
import { motion } from 'framer-motion';
import { CaretRight } from '@phosphor-icons/react';

import { Button } from '../ui/button';

const MotionButton = motion(Button);

interface FollowUpQuestionsProps {
  questions: string[];
  onQuestionClick: (question: string) => void;
}

export function FollowUpQuestions({ questions, onQuestionClick }: FollowUpQuestionsProps) {
  if (!questions.length) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="w-full"
    >
      <div className="rounded-lg overflow-hidden bg-card border">
        <h3 className="px-4 py-3 border-b border-b-dark-300 font-bold">Follow-up questions</h3>

        {questions.map((question, index) => {
          if (index < 3) {
            return (
              <MotionButton
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                onClick={() => onQuestionClick(question)}
                variant="ghost"
                className="w-full text-left"
              >
                <span className="flex-grow">{question}</span>
                <CaretRight className="" weight="bold" />
              </MotionButton>
            );
          }

          return null;
        })}
      </div>
    </motion.div>
  );
}
